<template>
  <span :class="classes" :style="styleOverride">
    <slot />
  </span>
</template>

<script>
const VARIANTS = {
  default: "border-transparent bg-primary text-primary-foreground",
  secondary: "border-transparent bg-secondary text-secondary-foreground",
  outline: "text-foreground",
  muted: "border-transparent bg-muted text-muted-foreground",
  destructive: "border-transparent bg-destructive text-white",
};

export default {
  name: "UiBadge",
  props: {
    variant: { type: String, default: "default" },
    color: { type: String, default: "" },
  },
  computed: {
    classes() {
      return [
        "inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-xs font-medium whitespace-nowrap",
        this.color ? "border-transparent text-white" : VARIANTS[this.variant] || VARIANTS.default,
      ];
    },
    styleOverride() {
      return this.color ? { backgroundColor: this.color } : {};
    },
  },
};
</script>
